import { Button, Checkbox, Col, ConfigProvider, Input, Table, Tooltip } from "antd";
import * as AllComponents from '../../home/components';
import { BaseComponent, IBaseComponent, IBaseProps } from "../infrastructure/baseComponent";
import { ILookupProps, ILookupStates } from "./interfaces";
import { MoreOutlined, DownOutlined, LoadingOutlined, CloseCircleFilled } from '@ant-design/icons';
import debounce from 'lodash/debounce';
import { enmControlType, enmPropertyType, IEntityManager, IMetadata, IProperty } from "../entityManager/interfaces";
import { Core } from "../infrastructure/core";
import { DebouncedFunc } from "lodash";
import dayjs from 'dayjs';
import React, { Component } from "react";
import { ColumnType } from "antd/lib/table";
import { CSSProperties } from "react";
import { enmOrderingType, IFetchingResult, IOrdering, IPaging } from "../infrastructure/models";
import ReactDOM from "react-dom";
import CustomSpinner from "../infrastructure/customSpinner";
import './index.css';
import { InputFocusOptions } from "antd/lib/input/Input";
import { jalaliLocale } from "../../home/jalaliLocale";

export class Lookup extends BaseComponent<ILookupProps, ILookupStates> {
    self?: HTMLDivElement | null;
    component?: IEntityManager;
    lookupProps?: IBaseProps;
    id: string;
    debouncedSearch?: DebouncedFunc<any>;
    isDropdownOpen: boolean = false;
    lookupBoxContainer?: Element;
    private lookupBox?: LookupBox | null;
    private input?: Input | null;
    constructor(props: ILookupProps) {
        super(props)
        const defaultValue = this.props.value && this.props.property.lookup?.lookupDisplayFields?.map(f => {
            let fields = f.split('.');
            let value = this.props.value;
            fields.forEach(i => {
                if (value)
                    value = value[i];
            });
            return value;
        })?.join(" ");
        this.state = {
            isAuthorized: true,
            loading: false,
            value: defaultValue,
            options: [],
            selectedItem: this.props.value,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            title: ''
        };

        if (!this.props.property.lookup)
            throw new Error(this.props.property.dataIndex + ": lookup not set...");

        this.id = Core.newId();
    }
    componentDidMount() {
        super.componentDidMount();

        const contentContainer = document.getElementById('content-container');
        const element = document.createElement("DIV");
        this.lookupBoxContainer = element;
        contentContainer!.appendChild(element);
        ReactDOM.render(
            <LookupBox
                key={this.id}
                parent={this.props.parent}
                getComponent={() => this.component}
                getProperty={() => this.props.property}
                ref={node => {
                    if (!this.lookupBox && !!node && this.mounted) {
                        this.lookupBox = node;
                        this.initializeComponent();
                    }
                }}
                getContainer={() => this.self}
                openIfEmpty={!this.props.allowTextChange}
                loading={loading => this.setLoading(loading)}
                style={{ direction: "rtl" }}
                onDataFetched={this.props.onDataFetched}
                onSelect={selectedItem => {
                    const title = selectedItem && this.props.property.lookup?.lookupDisplayFields?.map(f => {
                        let fields = f.split('.');
                        let value = selectedItem;
                        fields.forEach(i => {
                            value = value[i];
                        });
                        return value;
                    })?.join(" ");

                    this.setState({
                        value: title, selectedItem
                    });
                    this.props.onChange && this.props.onChange(selectedItem);
                }}
            />, element);
    }
    initializeComponent = () => {
        if (this.props.disabled)
            return;
        if (this.props.property.lookup?.lookupComponent) {
            this.lookupProps = {
                onClose: (sender) => {
                    this.props.onChange && this.props.onChange(sender.selectedEntity);

                    if (this.props.onLookupClose)
                        this.props.onLookupClose(sender.selectedEntity);

                    if (this.props.property.lookup) {
                        let lookup = this.props.property.lookup;

                        (this.props.parent as any).setState({ displayLookupForm: undefined });

                        const defaultValue = sender.selectedEntity && lookup.lookupDisplayFields?.map(f => {
                            let fields = f.split('.');
                            let value = sender.selectedEntity;
                            fields.forEach(i => {
                                value = value[i];
                            });
                            return value;
                        })?.join(" ");
                        this.setState({ value: defaultValue });
                    }
                },
                isLookupMode: true,
                isChildComponent: true,
                invokePath: this.props.parent.title
            };

            if (this.props.preparelookupProps) {
                this.lookupProps = this.props.preparelookupProps(this.lookupProps);
            }

            let lookupComponent = this.props.property.lookup.lookupComponent;
            const Component = typeof lookupComponent === "string" ? (AllComponents as any)[lookupComponent as string] : lookupComponent;
            if (this.props.parent) {
                (this.props.parent as any).setState({ displayLookupForm: undefined });
                this.props.parent.addLookupForm(this.id,
                    (<Component ref={(node: any) => {
                        if (node && this.mounted) {
                            this.component = node;
                            if (this.component?.metadata) {
                                this.component.preLoad = this.props.preLoad === true;
                                if (!this.state.title)
                                    this.setState({ title: this.component.metadata.title });
                                if (this.lookupBox && !this.lookupBox.state.metadata)
                                    this.lookupBox.initialize(this.component.metadata);
                            }
                        }
                    }} {...this.lookupProps} onDataFetched={this.lookupBox!.onDataFetched} />),
                    false);
            }
        }
    }
    componentWillMount() {
        this.debouncedSearch = debounce((value: string) => {
            this.onSearch(value);
        }, 700);
    }
    componentDidUpdate(prevProps: ILookupProps) {
        if (prevProps.value !== this.props.value) {
            const defaultValue = this.props.value && this.props.property.lookup?.lookupDisplayFields?.map(f => {
                let fields = f.split('.');
                let value = this.props.value;
                fields.forEach(i => {
                    if (value)
                        value = value[i];
                });
                return value;
            })?.join(" ");
            this.setState({ value: defaultValue });
        }

        if (prevProps.disabled && !this.props.disabled && !this.lookupProps)
            this.initializeComponent();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.debouncedSearch?.cancel();
        this.props.parent.destroyLookupForms(this.id);

        if (!!this.lookupBoxContainer) {
            ReactDOM.unmountComponentAtNode(this.lookupBoxContainer);
            this.lookupBoxContainer.remove();
        }
    }
    onSearch = async (value: string, selectedRowGuid?: string) => {
        this.lookupBox?.onSearch(value, selectedRowGuid);
    }
    onClear = () => {
        this.setState({ value: '', selectedItem: undefined });
        this.props.onChange && this.props.onChange(undefined);
    }
    focus = (options?: InputFocusOptions) => {
        this.input?.focus(options);
    }
    render() {
        const placeholder = `جستجوی لیست ${this.state.title}`;
        const value = !this.state.value ? this.props.defaultText : this.state.value;
        return (
            <div style={this.props.style}>
                <Col ref={node => this.self = node} className={`lookup ${this.props.disabled ? 'lookup-disabled' : ''}`} style={{ height: 32 }}>
                    <Input
                        autoComplete={"off"}
                        id={this.props.property.dataIndex}
                        suffix={
                            !!this.state.value && !this.props.disabled ? <CloseCircleFilled style={{ marginLeft: 2, color: 'lightgray' }} disabled={this.props.disabled} onClick={this.onClear} /> : <></>
                        }
                        onChange={event => {
                            this.setState({ value: event.target.value, selectedItem: undefined });
                            if (event.type === "change") {
                                this.debouncedSearch && this.debouncedSearch(event.target.value);
                                if (this.props.allowTextChange)
                                    this.props.onChange && this.props.onChange(event.target.value);
                            }
                            else
                                this.props.onChange && this.props.onChange(null);
                        }}
                        onFocus={() => {
                            this.self?.classList.add('lookup-focused');
                        }}
                        onBlur={() => {
                            this.self?.classList.remove('lookup-focused');
                            if (this.props.allowTextChange)
                                this.props.onChange && this.props.onChange(value);
                        }}
                        style={{ width: this.props.property.lookup?.showButton !== false ? "calc(100% - 62px)" : "calc(100% - 32px)", verticalAlign: 'middle', border: 'none', padding: "0px 10px 0px 2px" }}
                        value={value}
                        disabled={this.props.disabled}
                        placeholder={this.props.disabled ? '' : placeholder}
                        ref={node => this.input = node}
                    />
                    {
                        <Tooltip title={this.props.disabled ? '' : `مشاهده لیست ${this.state.title}`}>
                            <Button key="DropDownButton"
                                loading={this.state.loading}
                                style={{ border: 'none', verticalAlign: 'middle', height: '100%', borderRight: '1px solid #d9d9d9' }}
                                disabled={this.props.disabled || this.state.loading}
                                onClick={() => {
                                    if (this.state.selectedItem)
                                        this.onSearch('', this.state.selectedItem.RowGuid);
                                    else
                                        this.onSearch(this.state.value);
                                }}
                                icon={this.state.loading
                                    ? <LoadingOutlined style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: 12 }} />
                                    : <DownOutlined style={{ color: 'rgba(0, 0, 0, 0.25)', fontSize: 12 }} />
                                }
                            />
                        </Tooltip>

                    }
                    {
                        this.props.property.lookup?.showButton !== false
                            ?
                            <Tooltip title={this.state.title}>
                                <Button key="MoreButton" loading={this.state.loading}
                                    onClick={() => {
                                        this.props.onLookupOpen && this.props.onLookupOpen();
                                        (this.props.parent as any).setState({ displayLookupForm: this.id });
                                        this.component && this.component.fetchData();
                                    }}
                                    icon={<MoreOutlined size={20} rotate={90} />}
                                    style={{ marginRight: 1, width: 30, verticalAlign: 'middle', height: 30, border: 'none', borderRight: "1px solid #d9d9d9" }}
                                    disabled={this.props.disabled}
                                />
                            </Tooltip>
                            : <></>
                    }
                </Col>
            </div>
        );
    }
}
interface ILookupBoxStates {
    isOpen: boolean;
    loading: boolean;
    value?: string;
    datasource: any[];
    metadata?: IMetadata;
    width?: number;
    totalResultCount?: number;
    columns: ColumnType<any>[];
}
interface ILookupBoxProps {
    openIfEmpty?: boolean | null;
    parent: IBaseComponent;
    getComponent: () => IEntityManager | undefined;
    getProperty: () => IProperty;
    loading: { (loading: boolean): void };
    onSelect?: (data: any, index?: number, event?: React.MouseEvent<any, MouseEvent>) => any;
    style?: CSSProperties;
    getContainer: () => HTMLDivElement | null | undefined;
    onDataFetched?: (data: IFetchingResult<any>) => void;
}
class LookupBox extends Component<ILookupBoxProps, ILookupBoxStates> {
    listBox?: HTMLDivElement | null;
    paging: IPaging;
    ordering?: IOrdering;
    mounted: boolean;
    constructor(props: ILookupBoxProps) {
        super(props)
        this.state = {
            isOpen: false,
            loading: false,
            datasource: [],
            columns: []
        };
        this.paging = { PageNo: 1, PageSize: 10 };
        this.mounted = false;
    }
    componentDidMount() {
        this.mounted = true;
        window.addEventListener('resize', this.handleResize);
        const node = document.getElementById('content-container');
        node?.addEventListener('scroll', this.handleScroll);

    }
    initialize = (metadata: IMetadata) => {
        let width = 0;
        const property = this.props.getProperty();
        const displayProperties = metadata.Properties.filter(p => p.showInLookup !== false && (!property.lookup?.dropdownDisplayFields || property.lookup.dropdownDisplayFields.indexOf(p.dataIndex!) > -1)) ?? [];
        const columns = displayProperties.filter(c => c.showColumn !== false).map(c => {
            width += Number(c.width ?? 0);
            let newCol: ColumnType<any> = {};
            newCol.key = c.key ?? c.dataIndex;
            newCol.title = c.title;
            newCol.dataIndex = c.dataIndex;
            newCol.width = c.width;
            newCol.onCell = (record, rowIndex) => {
                return {
                    onClick: (event) => {
                        if (this.props.onSelect)
                            this.props.onSelect.call(this, record, rowIndex, event);
                    },
                };
            };
            newCol.responsive = ['lg', 'md', 'sm', 'xs'];
            newCol.render = (text, record: any, index) => {
                let result: any = null;
                if (c.renderColumn) {
                    result = c.renderColumn(text, record, index);
                }

                if (c.lookup?.lookupComponent && record) {
                    let displayData = record as any;
                    if (displayData[c.lookup?.lookupProperty!])
                        return (
                            <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <Col>{c.lookup?.lookupDisplayFields?.map(f => {
                                    let fields = f.split('.');
                                    let value = displayData[c.lookup?.lookupProperty!];
                                    fields.forEach(i => {
                                        value = value[i];
                                    });
                                    return value + " "
                                })}</Col>
                            </div>
                        );
                }

                result = result ?? text;

                let fields = c.dataIndex?.split('.');
                let value = record as any;
                fields?.forEach(i => {
                    if (value !== undefined && value !== null && value[i] !== undefined && value[i] !== null)
                        value = value[i];
                    else
                        value = undefined;
                });

                if (c.propertyType === enmPropertyType.boolean) {
                    return (<Checkbox key={record.RowGuid} checked={value} />);
                }
                if (c.combobox && (c.combobox.options || c.combobox.optionsFunc)) {
                    return (
                        <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {c.combobox.options?.find(o => o.value === value)?.title}
                            {c.combobox.optionsFunc && c.combobox.optionsFunc(this.props.parent, record).find(o => o.value === value)?.title}
                        </div>
                    );
                }
                if (c.propertyType === enmPropertyType.date) {
                    result = text ? dayjs(text).calendar('jalali').locale('fa').format("YYYY/MM/DD") : undefined;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>);
                }
                if (c.propertyType === enmPropertyType.datetime) {
                    result = value ? dayjs(value).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm") : undefined;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>);
                }
                if (c.controlType === enmControlType.numberinput) {
                    result = text;
                    if (value)
                        result = value;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {c.formatter ? c.formatter(result, {} as any) : result}
                    </div>);
                }
                if (c.controlType === enmControlType.priceinput) {
                    result = text;
                    if (value)
                        result = value;
                    return (<div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {`${result}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>);
                }
                if (!result && !!value)
                    result = value;
                return (
                    <div key={record.RowGuid} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {result}
                    </div>
                );
            };
            newCol.sorter = c.sortable !== false;
            return newCol;
        });

        this.setState({ columns, metadata, width });
    }
    onDataFetched = (result: IFetchingResult<any>) => {
        if (!this.mounted)
            return;
        const property = this.props.getProperty();
        const options: any[] = [];
        if (property.allowNull)
            options.push({ label: '...', value: null });

        result.Data!.forEach((item: any) => {
            let label = item && property.lookup?.lookupDisplayFields?.map(f => {
                let fields = f.split('.');
                let value = item;
                fields.forEach(i => {
                    value = value[i];
                });
                return value;
            })?.join(" ");
            options.push({
                key: item.RowGuid, label: label, value: item.Id.toString()
            });
        });
        this.props.onDataFetched && this.props.onDataFetched(result);
        this.setState({ datasource: result.Data!, loading: false, totalResultCount: result.TotalResultCount });
        this.props.loading(false);
    }
    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this.handleResize);
        const node = document.getElementById('content-container');
        node?.removeEventListener('scroll', this.handleScroll);
    }
    componentDidUpdate() {
        const { isOpen } = this.state;
        setTimeout(() => {
            if (isOpen) {
                window.addEventListener('click', this.close)
            }
            else {
                window.removeEventListener('click', this.close)
            }
        }, 100);
    }
    open = () => {
        if (this.mounted === false)
            return;
        setTimeout(() => {
            this.listBox?.classList.remove("lookup-box-hidden");
            this.listBox?.classList.add("lookup-box-show");
            this.setState({ isOpen: true });
        }, 100);
    }
    close = () => {
        if (this.mounted === false)
            return;
        this.listBox?.classList.add("lookup-box-hidden");
        this.listBox?.classList.remove("lookup-box-show");
        this.setState({ isOpen: false });
    }
    handleResize = () => {
        if (this.mounted && this.state.isOpen)
            this.setState({ isOpen: false });
    }
    handleScroll = () => {
        if (this.mounted && this.state.isOpen)
            this.setState({ isOpen: false });
    }
    onSearch = async (value?: string, selectedRowGuid?: string) => {
        if (!this.mounted)
            return;
        const property = this.props.getProperty();
        const component = this.props.getComponent();
        if (!!property.lookup && !!component) {
            this.props.loading(true);
            this.setState({ loading: true, value: value, isOpen: false });
            await component.search(value, selectedRowGuid, this.paging, this.ordering, true);
            if (!this.state.isOpen && (this.props.openIfEmpty || (!this.props.openIfEmpty && this.state.datasource?.length)))
                this.open();
        }
    }
    render() {
        const { PageNo, PageSize } = this.paging!;

        const contentContainer = document.getElementById('content-container');
        const container = this.props.getContainer();
        let style: CSSProperties = {};
        let exheight = 0;

        if (container && contentContainer && this.listBox && this.state.isOpen) {
            const parentBounding = container.getBoundingClientRect();
            const contentContainerBounding = contentContainer.getBoundingClientRect();
            const selfBounding = this.listBox.getBoundingClientRect();
            const availableHeightOnTop = parentBounding.top;
            const availableHeightOnBottom = contentContainerBounding.height - parentBounding.bottom;
            const width = Math.min(Math.max(parentBounding.width, this.state.width || 0), parentBounding.left + parentBounding.width - 20); //  عرض مورد نیاز جهت نمایش لیست
            style = {
                position: "absolute",
                overflowY: "hidden",
                top: 0,
                bottom: 0,
                height: 0,
                minHeight: 0,
                left: parentBounding.right - width,
                width: Math.floor(width).toString() + "px"
            };
            if (selfBounding.height <= availableHeightOnBottom) {
                style.top = parentBounding.bottom - 64;
                style.height = selfBounding.height;
            }
            else if (selfBounding.height <= availableHeightOnTop) {
                style.top = parentBounding.top - selfBounding.height - 64;
                style.height = selfBounding.height;
            }
            else if (availableHeightOnBottom > availableHeightOnTop) {
                style.top = parentBounding.bottom - 64;
                style.height = availableHeightOnBottom;
                exheight = selfBounding.height - availableHeightOnBottom;
            }
            else {
                style.bottom = parentBounding.top;
                style.height = availableHeightOnTop;
                exheight = selfBounding.height - availableHeightOnTop;
            }
        }

        return (
            <ConfigProvider locale={jalaliLocale} direction="rtl" >
                <div >
                    <div className="lookup-box" ref={node => this.listBox = node} onClick={this.close} style={style}>
                        <Table
                            rowKey="RowGuid"
                            sticky={{ getContainer: () => { return this.listBox!; } }}
                            showHeader={true}
                            columns={this.state.columns}
                            scroll={{ x: 'max-content', y: this.paging.PageSize * 30 - exheight }}
                            dataSource={this.state.datasource}
                            loading={this.state.loading && { indicator: <CustomSpinner /> }}
                            pagination={{
                                style: { marginRight: 10 },
                                position: ['bottomRight'],
                                defaultPageSize: this.paging?.PageSize ?? 10,
                                current: Math.ceil(this.state.totalResultCount ?? 0 / PageSize) < PageNo ? 1 : PageNo,
                                showSizeChanger: false,
                                total: this.state.totalResultCount,
                                showPrevNextJumpers: false,
                                showLessItems: true,
                                showQuickJumper: false,
                                size: 'small'
                            }}
                            onChange={(pagination, _, sorter) => {
                                if (!(sorter instanceof Array) && !!sorter.field && !!sorter.order) {
                                    this.ordering = {
                                        Property: sorter.field?.toString() ?? '',
                                        OrderBy: sorter.order === 'ascend' ? enmOrderingType.Ascending : enmOrderingType.Descending
                                    };
                                }
                                if (this.paging) {
                                    this.paging.PageNo = pagination.current ?? 1;
                                    this.paging.PageSize = pagination.pageSize ?? 10;
                                }
                                this.onSearch(this.state.value);
                            }}
                            onRow={() => {
                                return {
                                    className: "lookup-row",
                                    //onClick: (event) => {
                                    //    if (this.props.onSelect)
                                    //        this.props.onSelect.call(this, record, rowIndex, event);
                                    //}
                                };
                            }}
                        />
                    </div>
                </div>
            </ConfigProvider>
        );
    }

}